import { useChainId } from 'libs/wallet';
import { ChainId } from 'types';

export const featureFlags = {
  integratedSwap: [ChainId.BSC_MAINNET],
  prime: [
    ChainId.BSC_MAINNET,
    ChainId.BSC_TESTNET,
    ChainId.SEPOLIA,
    ChainId.ETHEREUM,
    ChainId.ARBITRUM_SEPOLIA,
    ChainId.ARBITRUM_ONE,
    ChainId.ZKSYNC_SEPOLIA,
    ChainId.ZKSYNC_MAINNET,
    ChainId.OPTIMISM_MAINNET,
    ChainId.OPTIMISM_SEPOLIA,
  ],
  primeCalculator: [ChainId.ETHEREUM, ChainId.SEPOLIA, ChainId.ARBITRUM_SEPOLIA],
  tusdMigrationWarning: [ChainId.BSC_MAINNET],
  trxMigrationWarning: [ChainId.BSC_MAINNET],
  sxpDisablingWarning: [ChainId.BSC_MAINNET],
  bethUpdateWarning: [ChainId.BSC_MAINNET],
  vaiRoute: [ChainId.BSC_MAINNET, ChainId.BSC_TESTNET],
  swapRoute: [ChainId.BSC_TESTNET],
  createProposal: [ChainId.BSC_MAINNET, ChainId.BSC_TESTNET],
  voteProposal: [ChainId.BSC_MAINNET, ChainId.BSC_TESTNET],
  apyCharts: [
    ChainId.BSC_MAINNET,
    ChainId.BSC_TESTNET,
    ChainId.ETHEREUM,
    ChainId.SEPOLIA,
    ChainId.OPBNB_MAINNET,
    ChainId.OPBNB_TESTNET,
    ChainId.ARBITRUM_ONE,
    ChainId.ZKSYNC_SEPOLIA,
    ChainId.ZKSYNC_MAINNET,
    ChainId.OPTIMISM_MAINNET,
    ChainId.OPTIMISM_SEPOLIA,
    ChainId.BASE_MAINNET,
    ChainId.BASE_SEPOLIA,
    ChainId.UNICHAIN_MAINNET,
    ChainId.UNICHAIN_SEPOLIA,
  ],
  marketParticipantCounts: [
    ChainId.BSC_MAINNET,
    ChainId.BSC_TESTNET,
    ChainId.OPBNB_MAINNET,
    ChainId.ETHEREUM,
    ChainId.SEPOLIA,
    ChainId.ARBITRUM_ONE,
    ChainId.ARBITRUM_SEPOLIA,
    ChainId.ZKSYNC_SEPOLIA,
    ChainId.ZKSYNC_MAINNET,
    ChainId.OPTIMISM_SEPOLIA,
    ChainId.OPTIMISM_MAINNET,
    ChainId.BASE_MAINNET,
    ChainId.BASE_SEPOLIA,
    ChainId.UNICHAIN_MAINNET,
    ChainId.UNICHAIN_SEPOLIA,
  ],
  bridgeRoute: [
    ChainId.BSC_MAINNET,
    ChainId.BSC_TESTNET,
    ChainId.ETHEREUM,
    ChainId.SEPOLIA,
    ChainId.OPBNB_MAINNET,
    ChainId.OPBNB_TESTNET,
    ChainId.ARBITRUM_SEPOLIA,
    ChainId.ARBITRUM_ONE,
    ChainId.ZKSYNC_SEPOLIA,
    ChainId.ZKSYNC_MAINNET,
    ChainId.OPTIMISM_MAINNET,
    ChainId.OPTIMISM_SEPOLIA,
    ChainId.BASE_MAINNET,
    ChainId.BASE_SEPOLIA,
    ChainId.UNICHAIN_SEPOLIA,
    ChainId.UNICHAIN_MAINNET,
  ],
  wrapUnwrapNativeToken: [
    ChainId.BSC_MAINNET,
    ChainId.BSC_TESTNET,
    ChainId.ETHEREUM,
    ChainId.SEPOLIA,
    ChainId.OPBNB_MAINNET,
    ChainId.OPBNB_TESTNET,
    ChainId.ARBITRUM_SEPOLIA,
    ChainId.ARBITRUM_ONE,
    ChainId.ZKSYNC_SEPOLIA,
    ChainId.ZKSYNC_MAINNET,
    ChainId.OPTIMISM_MAINNET,
    ChainId.OPTIMISM_SEPOLIA,
    ChainId.BASE_MAINNET,
    ChainId.BASE_SEPOLIA,
    ChainId.UNICHAIN_MAINNET,
    ChainId.UNICHAIN_SEPOLIA,
  ],
  gaslessTransactions: [] as ChainId[],
  web3DomainNames: [ChainId.BSC_MAINNET, ChainId.ETHEREUM, ChainId.ARBITRUM_ONE],
  burnedWBnbButton: [ChainId.BSC_MAINNET],
  importPositions: [
    ChainId.BSC_MAINNET,
    ChainId.BSC_TESTNET,
    ChainId.ETHEREUM,
    ChainId.SEPOLIA,
    ChainId.OPTIMISM_MAINNET,
    ChainId.OPTIMISM_SEPOLIA,
    ChainId.BASE_MAINNET,
    ChainId.BASE_SEPOLIA,
  ],
  importAavePositions: [
    ChainId.BSC_MAINNET,
    ChainId.BSC_TESTNET,
    ChainId.ARBITRUM_ONE,
    ChainId.ARBITRUM_SEPOLIA,
    ChainId.ETHEREUM,
    ChainId.SEPOLIA,
    ChainId.OPTIMISM_MAINNET,
    ChainId.OPTIMISM_SEPOLIA,
    ChainId.ZKSYNC_MAINNET,
    ChainId.ZKSYNC_SEPOLIA,
    ChainId.BASE_MAINNET,
    ChainId.BASE_SEPOLIA,
    ChainId.UNICHAIN_MAINNET,
    ChainId.UNICHAIN_SEPOLIA,
  ],
  eMode: [
    ChainId.BSC_MAINNET,
    ChainId.BSC_TESTNET,
    ChainId.OPBNB_TESTNET,
    ChainId.SEPOLIA,
    ChainId.ARBITRUM_SEPOLIA,
    ChainId.ZKSYNC_SEPOLIA,
    ChainId.OPTIMISM_SEPOLIA,
    ChainId.BASE_SEPOLIA,
    ChainId.UNICHAIN_SEPOLIA,
  ],
  transactionHistory: [
    ChainId.BSC_MAINNET,
    ChainId.BSC_TESTNET,
    ChainId.ETHEREUM,
    ChainId.UNICHAIN_MAINNET,
  ],
  leveragedPositions: [ChainId.BSC_MAINNET, ChainId.BSC_TESTNET],
  repayWithCollateral: [ChainId.BSC_MAINNET, ChainId.BSC_TESTNET],
  statsRoute: [ChainId.BSC_MAINNET, ChainId.BSC_TESTNET],
  trade: [ChainId.BSC_MAINNET, ChainId.BSC_TESTNET],
  primeLeaderboard: [ChainId.BSC_MAINNET, ChainId.BSC_TESTNET],
};

export type FeatureFlag = keyof typeof featureFlags;

export interface UseIsFeatureEnabledInput {
  name: FeatureFlag;
}

export const useIsFeatureEnabled = ({ name }: UseIsFeatureEnabledInput) => {
  const { chainId } = useChainId();
  return featureFlags[name].includes(chainId);
};
